// Utility management module for PPT Hero game
export default class UtilityManager {
  constructor(scene) {
    this.scene = scene;
  }

  // Split text into lines for better display
  splitTextIntoLines(text, maxChars) {
    if (text.length <= maxChars) return [text];
    
    const words = text.split(' ');
    const lines = [];
    let currentLine = '';
    
    for (const word of words) {
      if ((currentLine + ' ' + word).length <= maxChars) {
        currentLine = currentLine ? currentLine + ' ' + word : word;
      } else {
        if (currentLine) lines.push(currentLine);
        currentLine = word;
      }
    }
    
    if (currentLine) lines.push(currentLine);
    
    // If we still have lines that are too long, split them
    if (lines.length === 1 && lines[0].length > maxChars) {
      return [lines[0].substring(0, maxChars), lines[0].substring(maxChars)];
    }
    
    return lines;
  }

  // Calculate star rating based on score
  calculateStarRating(score, numLevels = 10) {
    const maxScore = numLevels * 100; // Assuming 100 points per level
    const percentage = (score / maxScore) * 100;
    
    if (percentage >= 90) return 5;
    if (percentage >= 75) return 4;
    if (percentage >= 60) return 3;
    if (percentage >= 45) return 2;
    if (percentage >= 30) return 1;
    return 0;
  }

  // Update star rating display
  updateStarRating(stars, score) {
    if (!stars || !Array.isArray(stars)) return;
    
    const rating = this.calculateStarRating(score);
    
    stars.forEach((star, index) => {
      if (star && star.setTexture) {
        if (index < rating) {
          star.setTexture('star-filled');
          star.setFillStyle(0xffff00, 1.0);
        } else {
          star.setTexture('star-empty');
          star.setFillStyle(0x666666, 1.0);
        }
      }
    });
  }

  // Show a simple message
  showMessage(text, duration = 1500) {
    if (this.scene.messageDisplay) {
      this.scene.messageDisplay.destroy();
    }
    
    this.scene.messageDisplay = this.scene.add.text(
      this.scene.cameras.main.width / 2,
      this.scene.cameras.main.height / 2 + 100,
      text,
      {
        ...this.scene.getProfessionalTextStyle("24px", "#ffffff"),
        backgroundColor: "#1a252f",
        padding: { x: 20, y: 10 }
      }
    ).setOrigin(0.5);
    
    this.scene.time.delayedCall(duration, () => {
      if (this.scene.messageDisplay) {
        this.scene.messageDisplay.destroy();
        this.scene.messageDisplay = null;
      }
    });
  }
}



